// extracted by mini-css-extract-plugin
export var noSpinners = "_oj-6";
export var percentageInput = "_oj-7";
export var variantColor1 = "_oj-0";
export var variantColor2 = "_oj-1";
export var variantColor3 = "_oj-2";
export var variantColor4 = "_oj-3";
export var variantColor5 = "_oj-4";
export var variantColor6 = "_oj-5";